import { useEffect } from 'react';

import type { Viewer } from '@vimeo/viewer';

export const useDatadogSetUser = (viewer?: Viewer | null) => {
  useEffect(() => {
    if (viewer && window.DD_RUM) {
      window.DD_RUM.onReady(() => {
        window.DD_RUM.setUser({
          id: String(viewer.user?.id || ''),
          accountType: viewer.user?.account || '',
          teamOwnerId: String(viewer.teamUser?.ownerId || ''),
          teamOwnerAccountType: viewer.teamUser?.accountType || '',
        });
      });
    }
  }, [viewer]);
};
